import { getProductLabel, getProductTitle } from "../utils/sale.utils/index.js";
import { CART_PRODUCT_TYPES } from "../constants/index.js";
export var activitiesSkusFactory = function activitiesSkusFactory(_ref) {
  var cartsObject = _ref.cartsObject,
    productCartType = _ref.productCartType;
  return {
    skus: cartsObject.find(function (cartObject) {
      return cartObject.type === productCartType;
    }).products.find(function (product) {
      return product.type === productCartType;
    }).options.activityOrderDetail.activity.packages.map(function (_package) {
      return _package.skus.map(function (sku) {
        return {
          id: sku.id,
          title: sku.title
        };
      });
    }).reduce(function (arr, el) {
      return [].concat(arr, el);
    })
  };
};
export var totalBreakDownFactory = function totalBreakDownFactory(_ref2) {
  var _displayItems$total, _displayItems$total2, _displayItems$total3, _displayItems$total$s, _displayItems$total4;
  var displayItems = _ref2.displayItems,
    _ref2$formatPrice = _ref2.formatPrice,
    formatPrice = _ref2$formatPrice === void 0 ? function (a) {
      return a;
    } : _ref2$formatPrice;
  var total = displayItems === null || displayItems === void 0 ? void 0 : (_displayItems$total = displayItems.total) === null || _displayItems$total === void 0 ? void 0 : _displayItems$total.total;
  var displayedTotal = formatPrice(total);
  var totalToBePaid = displayItems === null || displayItems === void 0 ? void 0 : (_displayItems$total2 = displayItems.total) === null || _displayItems$total2 === void 0 ? void 0 : _displayItems$total2.totalToBePaid;
  var displayedTotalToBePaid = formatPrice(totalToBePaid);
  var totalCurrency = displayItems === null || displayItems === void 0 ? void 0 : (_displayItems$total3 = displayItems.total) === null || _displayItems$total3 === void 0 ? void 0 : _displayItems$total3.currency;
  var subtotal = (_displayItems$total$s = displayItems === null || displayItems === void 0 ? void 0 : displayItems.total.subTotal) !== null && _displayItems$total$s !== void 0 ? _displayItems$total$s : 0;
  var displayedSubtotal = formatPrice(subtotal);
  var vat = displayItems === null || displayItems === void 0 ? void 0 : (_displayItems$total4 = displayItems.total) === null || _displayItems$total4 === void 0 ? void 0 : _displayItems$total4.vat;
  var displayedVat = formatPrice(vat);
  var totalWithoutVat = subtotal;
  var displayedTotalWithoutVat = formatPrice(totalWithoutVat);
  var includeTotalWithVat = displayItems === null || displayItems === void 0 ? void 0 : displayItems.includeTotalWithVat;
  return {
    total: total,
    displayedTotal: displayedTotal,
    totalToBePaid: totalToBePaid,
    displayedTotalToBePaid: displayedTotalToBePaid,
    totalCurrency: totalCurrency,
    subtotal: subtotal,
    displayedSubtotal: displayedSubtotal,
    vat: vat,
    displayedVat: displayedVat,
    totalWithoutVat: totalWithoutVat,
    displayedTotalWithoutVat: displayedTotalWithoutVat,
    includeTotalWithVat: includeTotalWithVat
  };
};
var reorderPriceBreakDown = function reorderPriceBreakDown(_ref3) {
  var saleStore = _ref3.saleStore,
    hasMultiCart = _ref3.hasMultiCart,
    priceBreakDown = _ref3.priceBreakDown;
  var filteredPriceBreakdown = priceBreakDown;
  var ordersKey = saleStore.saleNumber ? 'orders' : 'carts';
  var relatedToOrderKey = saleStore.saleNumber ? 'relatedToOrder' : 'relatedToCart';
  var orderIdKey = saleStore.saleNumber ? 'orderId' : 'cartId';
  var orderNumberKey = saleStore.saleNumber ? 'orderNumber' : 'cartId';
  if (hasMultiCart) {
    var _saleStore$ordersKey, _saleStore$ordersKey2;
    filteredPriceBreakdown = [];
    var mainOrders = saleStore === null || saleStore === void 0 ? void 0 : (_saleStore$ordersKey = saleStore[ordersKey]) === null || _saleStore$ordersKey === void 0 ? void 0 : _saleStore$ordersKey.filter(function (order) {
      return !(order !== null && order !== void 0 && order[relatedToOrderKey]);
    });
    var addonOrders = saleStore === null || saleStore === void 0 ? void 0 : (_saleStore$ordersKey2 = saleStore[ordersKey]) === null || _saleStore$ordersKey2 === void 0 ? void 0 : _saleStore$ordersKey2.filter(function (order) {
      return order === null || order === void 0 ? void 0 : order[relatedToOrderKey];
    });
    mainOrders.forEach(function (mainOrder) {
      var sectionIndex = priceBreakDown.findIndex(function (section) {
        return (section === null || section === void 0 ? void 0 : section.id) === (mainOrder === null || mainOrder === void 0 ? void 0 : mainOrder[orderNumberKey]);
      });
      if (priceBreakDown[sectionIndex]) {
        filteredPriceBreakdown.push(priceBreakDown[sectionIndex]);
        if (priceBreakDown[sectionIndex + 1]) {
          filteredPriceBreakdown.push(priceBreakDown[sectionIndex + 1]);
        }
        var relatedAddons = addonOrders.filter(function (addonOrder) {
          var _addonOrder$relatedTo;
          return (addonOrder === null || addonOrder === void 0 ? void 0 : (_addonOrder$relatedTo = addonOrder[relatedToOrderKey]) === null || _addonOrder$relatedTo === void 0 ? void 0 : _addonOrder$relatedTo[orderIdKey]) === (mainOrder === null || mainOrder === void 0 ? void 0 : mainOrder[orderIdKey]);
        });
        if (relatedAddons.length > 0) {
          relatedAddons.forEach(function (addon) {
            var addonSectionIndex = priceBreakDown.findIndex(function (section) {
              return (section === null || section === void 0 ? void 0 : section.id) === (addon === null || addon === void 0 ? void 0 : addon[orderNumberKey]);
            });
            if (priceBreakDown[addonSectionIndex]) {
              var _priceBreakDown, _priceBreakDown$, _priceBreakDown$addon;
              var title = (priceBreakDown === null || priceBreakDown === void 0 ? void 0 : (_priceBreakDown = priceBreakDown[addonSectionIndex + 1]) === null || _priceBreakDown === void 0 ? void 0 : (_priceBreakDown$ = _priceBreakDown[0]) === null || _priceBreakDown$ === void 0 ? void 0 : _priceBreakDown$.label) || ((_priceBreakDown$addon = priceBreakDown[addonSectionIndex]) === null || _priceBreakDown$addon === void 0 ? void 0 : _priceBreakDown$addon.label);
              filteredPriceBreakdown.push({
                title: title,
                id: priceBreakDown[addonSectionIndex].id
              });
              if (priceBreakDown[addonSectionIndex + 1]) {
                filteredPriceBreakdown.push(priceBreakDown[addonSectionIndex + 1]);
              }
            }
          });
        }
      }
    });
    filteredPriceBreakdown.push(priceBreakDown[priceBreakDown.length - 2]);
    filteredPriceBreakdown.push(priceBreakDown[priceBreakDown.length - 1]);
  }
  return filteredPriceBreakdown;
};
export var priceBreakDownFactory = function priceBreakDownFactory(_ref4) {
  var saleStore = _ref4.saleStore,
    _ref4$formatPrice = _ref4.formatPrice,
    formatPrice = _ref4$formatPrice === void 0 ? function (a) {
      return a;
    } : _ref4$formatPrice;
  var breakdownItems = [];
  var keyToReadPrice = saleStore.totalBreakDown.includeTotalWithVat ? 'totalWithVat' : 'subTotal';
  var keyToReadCartsObject = saleStore.saleNumber ? 'bookings' : 'cartsObject';
  var totalToBePaidKey = saleStore.saleNumber ? 'displayedTotal' : 'displayedTotalToBePaid';
  var totalToBePaidLocalization = saleStore.saleNumber ? 'Payment.Sale.PaymentDetails.OverallTotal' : 'Payment.Sale.PaymentDetails.TotalToBePaid';
  var currency = saleStore.totalBreakDown.totalCurrency;
  var keyToReadCarts = saleStore.saleNumber ? 'orders' : 'carts';
  var pushProductLine = function pushProductLine(_ref5) {
    var section = _ref5.section,
      cart = _ref5.cart,
      cartType = _ref5.cartType;
    if (cartType === CART_PRODUCT_TYPES.FLIGHT) {
      var _cart$displayItems, _cart$displayItems$li;
      var flightLineItem = cart === null || cart === void 0 ? void 0 : (_cart$displayItems = cart.displayItems) === null || _cart$displayItems === void 0 ? void 0 : (_cart$displayItems$li = _cart$displayItems.lineItems) === null || _cart$displayItems$li === void 0 ? void 0 : _cart$displayItems$li.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.type) === cartType;
      });
      if (flightLineItem !== null && flightLineItem !== void 0 && flightLineItem.breakdown) {
        var _flightLineItem$break;
        if ((flightLineItem === null || flightLineItem === void 0 ? void 0 : (_flightLineItem$break = flightLineItem.breakdown) === null || _flightLineItem$break === void 0 ? void 0 : _flightLineItem$break.length) > 0) {
          var _flightLineItem$break2;
          flightLineItem === null || flightLineItem === void 0 ? void 0 : (_flightLineItem$break2 = flightLineItem.breakdown) === null || _flightLineItem$break2 === void 0 ? void 0 : _flightLineItem$break2.forEach(function (travellers) {
            var _cart$products, _cart$products$find;
            var travellerInsideProduct = cart === null || cart === void 0 ? void 0 : (_cart$products = cart.products) === null || _cart$products === void 0 ? void 0 : (_cart$products$find = _cart$products.find(function (p) {
              return p.type === cartType;
            })) === null || _cart$products$find === void 0 ? void 0 : _cart$products$find.traveller;
            var traveller = travellerInsideProduct === null || travellerInsideProduct === void 0 ? void 0 : travellerInsideProduct.find(function (traveller) {
              return (travellers === null || travellers === void 0 ? void 0 : travellers.id) === (traveller === null || traveller === void 0 ? void 0 : traveller.id);
            });
            var travellerSection = {
              label: traveller ? traveller.title + " " + traveller.firstName + " " + traveller.lastName + " (" + traveller.type + ")" : "Traveller " + " " + (travellers === null || travellers === void 0 ? void 0 : travellers.type) + " " + (travellers === null || travellers === void 0 ? void 0 : travellers.ref),
              price: currency + " " + formatPrice(travellers.total),
              data: [],
              type: 'flight-breakdown'
            };
            travellers.details.forEach(function (detail) {
              travellerSection.data.push({
                label: "Payment.Sale.PaymentDetails." + detail.key,
                price: currency + " " + formatPrice(detail.amount)
              });
            });
            section.push(travellerSection);
          });
        } else {
          var _flightLineItem$price, _flightLineItem$price2;
          var price = ((flightLineItem === null || flightLineItem === void 0 ? void 0 : (_flightLineItem$price = flightLineItem.price) === null || _flightLineItem$price === void 0 ? void 0 : _flightLineItem$price.subTotal) || 0) + ((flightLineItem === null || flightLineItem === void 0 ? void 0 : (_flightLineItem$price2 = flightLineItem.price) === null || _flightLineItem$price2 === void 0 ? void 0 : _flightLineItem$price2.vat) || 0);
          section.push({
            label: 'Flight',
            price: currency + " " + formatPrice(price)
          });
        }
      } else {
        var _cart$products2, _cart$displayItems2, _cart$displayItems2$l, _cart$displayItems2$l2;
        section.push({
          label: getProductLabel({
            type: cartType,
            product: cart === null || cart === void 0 ? void 0 : (_cart$products2 = cart.products) === null || _cart$products2 === void 0 ? void 0 : _cart$products2.find(function (p) {
              return (p === null || p === void 0 ? void 0 : p.type) === cartType;
            })
          }),
          price: currency + " " + formatPrice(cart === null || cart === void 0 ? void 0 : (_cart$displayItems2 = cart.displayItems) === null || _cart$displayItems2 === void 0 ? void 0 : (_cart$displayItems2$l = _cart$displayItems2.lineItems) === null || _cart$displayItems2$l === void 0 ? void 0 : (_cart$displayItems2$l2 = _cart$displayItems2$l.find(function (lineItem) {
            return (lineItem === null || lineItem === void 0 ? void 0 : lineItem.type) === cartType;
          })) === null || _cart$displayItems2$l2 === void 0 ? void 0 : _cart$displayItems2$l2.price[keyToReadPrice])
        });
      }
    } else if (cartType === CART_PRODUCT_TYPES.ACTIVITIES) {
      var _cart$displayItems3, _cart$displayItems4, _activityLineItem$bre;
      var totalKey = cart !== null && cart !== void 0 && (_cart$displayItems3 = cart.displayItems) !== null && _cart$displayItems3 !== void 0 && _cart$displayItems3.includeTotalWithVat ? 'totalWithVat' : 'total';
      var activityLineItem = cart === null || cart === void 0 ? void 0 : (_cart$displayItems4 = cart.displayItems) === null || _cart$displayItems4 === void 0 ? void 0 : _cart$displayItems4.lineItems.find(function (p) {
        return (p === null || p === void 0 ? void 0 : p.type) === cartType;
      });
      activityLineItem === null || activityLineItem === void 0 ? void 0 : (_activityLineItem$bre = activityLineItem.breakdown) === null || _activityLineItem$bre === void 0 ? void 0 : _activityLineItem$bre.forEach(function (sku) {
        var _cart$products3, _cart$products3$find, _cart$products3$find$, _cart$products3$find$2, _cart$products3$find$3, _cart$products3$find$4, _cart$products3$find$5, _cart$products3$find$6;
        var skuTitle = cart === null || cart === void 0 ? void 0 : (_cart$products3 = cart.products) === null || _cart$products3 === void 0 ? void 0 : (_cart$products3$find = _cart$products3.find(function (p) {
          return p.type === cartType;
        })) === null || _cart$products3$find === void 0 ? void 0 : (_cart$products3$find$ = _cart$products3$find.options) === null || _cart$products3$find$ === void 0 ? void 0 : (_cart$products3$find$2 = _cart$products3$find$.activityOrderDetail) === null || _cart$products3$find$2 === void 0 ? void 0 : (_cart$products3$find$3 = _cart$products3$find$2.activity) === null || _cart$products3$find$3 === void 0 ? void 0 : (_cart$products3$find$4 = _cart$products3$find$3.packages[0]) === null || _cart$products3$find$4 === void 0 ? void 0 : (_cart$products3$find$5 = _cart$products3$find$4.skus) === null || _cart$products3$find$5 === void 0 ? void 0 : (_cart$products3$find$6 = _cart$products3$find$5.find(function (productSku) {
          return "" + (productSku === null || productSku === void 0 ? void 0 : productSku.id) === (sku === null || sku === void 0 ? void 0 : sku.id);
        })) === null || _cart$products3$find$6 === void 0 ? void 0 : _cart$products3$find$6.title;
        section.push({
          label: sku.qty + " x " + skuTitle,
          price: currency + " " + formatPrice(sku[totalKey])
        });
      });
    } else {
      var _cart$displayItems5, _cart$displayItems5$l, _priceLineItem$price, _priceLineItem$price2, _cart$products4;
      var priceLineItem = cart === null || cart === void 0 ? void 0 : (_cart$displayItems5 = cart.displayItems) === null || _cart$displayItems5 === void 0 ? void 0 : (_cart$displayItems5$l = _cart$displayItems5.lineItems) === null || _cart$displayItems5$l === void 0 ? void 0 : _cart$displayItems5$l.find(function (lineItem) {
        return (lineItem === null || lineItem === void 0 ? void 0 : lineItem.type) === cartType;
      });
      var _price = (priceLineItem === null || priceLineItem === void 0 ? void 0 : priceLineItem.price[keyToReadPrice]) || ((priceLineItem === null || priceLineItem === void 0 ? void 0 : (_priceLineItem$price = priceLineItem.price) === null || _priceLineItem$price === void 0 ? void 0 : _priceLineItem$price.subTotal) || 0) + ((priceLineItem === null || priceLineItem === void 0 ? void 0 : (_priceLineItem$price2 = priceLineItem.price) === null || _priceLineItem$price2 === void 0 ? void 0 : _priceLineItem$price2.vat) || 0);
      section.push({
        label: getProductLabel({
          type: cartType,
          product: cart === null || cart === void 0 ? void 0 : (_cart$products4 = cart.products) === null || _cart$products4 === void 0 ? void 0 : _cart$products4.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.type) === cartType;
          })
        }),
        price: currency + " " + formatPrice(_price)
      });
    }
  };
  var pushCouponLinePerCart = function pushCouponLinePerCart(_ref6) {
    var _cart$displayItems6, _cart$displayItems6$l;
    var section = _ref6.section,
      cart = _ref6.cart;
    var couponLineItem = cart === null || cart === void 0 ? void 0 : (_cart$displayItems6 = cart.displayItems) === null || _cart$displayItems6 === void 0 ? void 0 : (_cart$displayItems6$l = _cart$displayItems6.lineItems) === null || _cart$displayItems6$l === void 0 ? void 0 : _cart$displayItems6$l.find(function (lineItem) {
      return lineItem.category === CART_PRODUCT_TYPES.COUPON;
    });
    if (couponLineItem) {
      var _couponLineItem$name, _couponLineItem$price, _couponLineItem$price2;
      section.push({
        label: couponLineItem !== null && couponLineItem !== void 0 && couponLineItem.name ? couponLineItem === null || couponLineItem === void 0 ? void 0 : (_couponLineItem$name = couponLineItem.name) === null || _couponLineItem$name === void 0 ? void 0 : _couponLineItem$name.toUpperCase() : cart === null || cart === void 0 ? void 0 : cart.coupon,
        price: currency + " " + formatPrice((couponLineItem === null || couponLineItem === void 0 ? void 0 : couponLineItem.price[keyToReadPrice]) || ((couponLineItem === null || couponLineItem === void 0 ? void 0 : (_couponLineItem$price = couponLineItem.price) === null || _couponLineItem$price === void 0 ? void 0 : _couponLineItem$price.subTotal) || 0) + ((couponLineItem === null || couponLineItem === void 0 ? void 0 : (_couponLineItem$price2 = couponLineItem.price) === null || _couponLineItem$price2 === void 0 ? void 0 : _couponLineItem$price2.vat) || 0)),
        isNegativeRule: true
      });
    }
  };
  var pushRulesLinePerCart = function pushRulesLinePerCart(_ref7) {
    var _cart$displayItems7, _cart$displayItems7$l;
    var section = _ref7.section,
      cart = _ref7.cart;
    var rules = cart === null || cart === void 0 ? void 0 : (_cart$displayItems7 = cart.displayItems) === null || _cart$displayItems7 === void 0 ? void 0 : (_cart$displayItems7$l = _cart$displayItems7.lineItems) === null || _cart$displayItems7$l === void 0 ? void 0 : _cart$displayItems7$l.filter(function (lineItem) {
      return lineItem.category === CART_PRODUCT_TYPES.RULE;
    });
    rules.forEach(function (rule) {
      var _rule$price, _rule$price2;
      var isNegativeRule = (rule === null || rule === void 0 ? void 0 : rule.price[keyToReadPrice]) < 0;
      var label = isNegativeRule ? {
        key: 'Payment.Sale.PaymentDetails.Discount',
        data: {
          ruleName: rule.name || 'Discount'
        }
      } : rule.name || 'Service Fee';
      section.push({
        label: label,
        price: currency + " " + formatPrice((rule === null || rule === void 0 ? void 0 : rule.price[keyToReadPrice]) || ((rule === null || rule === void 0 ? void 0 : (_rule$price = rule.price) === null || _rule$price === void 0 ? void 0 : _rule$price.subTotal) || 0) + ((rule === null || rule === void 0 ? void 0 : (_rule$price2 = rule.price) === null || _rule$price2 === void 0 ? void 0 : _rule$price2.vat) || 0)),
        isNegativeRule: isNegativeRule
      });
    });
  };
  var pushLoyaltyLine = function pushLoyaltyLine(section) {
    var _saleStore$payments;
    var loyalty = saleStore === null || saleStore === void 0 ? void 0 : (_saleStore$payments = saleStore.payments) === null || _saleStore$payments === void 0 ? void 0 : _saleStore$payments.find(function (lineItem) {
      return lineItem.type === CART_PRODUCT_TYPES.LOYALTY;
    });
    if (loyalty) {
      section.push({
        label: loyalty.category,
        price: currency + " -" + formatPrice(loyalty === null || loyalty === void 0 ? void 0 : loyalty.price[keyToReadPrice]),
        isNegativeRule: true,
        type: 'loyalty'
      });
      section.push({
        horizontalLine: true,
        label: totalToBePaidLocalization,
        price: currency + " " + formatPrice(saleStore.totalBreakDown[totalToBePaidKey]),
        bold: true
      });
    }
  };
  var pushSubtotalLine = function pushSubtotalLine(section) {
    if (!saleStore.totalBreakDown.includeTotalWithVat) {
      section.push({
        horizontalLine: true,
        label: 'Payment.Sale.PaymentDetails.Subtotal',
        price: currency + " " + formatPrice(saleStore.totalBreakDown.displayedSubtotal)
      });
      section.push({
        label: 'Payment.Sale.PaymentDetails.VAT',
        price: currency + " " + formatPrice(saleStore.totalBreakDown.displayedVat)
      });
    }
  };
  var pushSubtotalLinePerCart = function pushSubtotalLinePerCart(_ref8) {
    var section = _ref8.section,
      cart = _ref8.cart;
    if (!cart.displayItems.includeTotalWithVat) {
      section.push({
        horizontalLine: true,
        label: 'Payment.Sale.PaymentDetails.Subtotal',
        price: currency + " " + formatPrice(cart.displayItems.total.subTotal)
      });
      section.push({
        label: 'Payment.Sale.PaymentDetails.VAT',
        price: currency + " " + formatPrice(cart.displayItems.total.vat)
      });
    }
  };
  var pushTourismFeesLinePerCart = function pushTourismFeesLinePerCart(_ref9) {
    var section = _ref9.section,
      cart = _ref9.cart,
      cartType = _ref9.cartType;
    if (cartType === 'hotel') {
      var _cart$products5;
      var hotelProduct = (_cart$products5 = cart.products) === null || _cart$products5 === void 0 ? void 0 : _cart$products5.find(function (p) {
        return p.type === cartType;
      });
      if (hotelProduct) {
        var _hotelProduct$options;
        var tourismFee = hotelProduct === null || hotelProduct === void 0 ? void 0 : (_hotelProduct$options = hotelProduct.options) === null || _hotelProduct$options === void 0 ? void 0 : _hotelProduct$options.tourismFee;
        if (tourismFee !== null && tourismFee !== void 0 && tourismFee.feeCurrency) {
          section.push({
            tourismFee: tourismFee
          });
        }
      }
    }
  };
  if (!saleStore.hasMultiCart) {
    var _saleStore$keyToReadC;
    var section = [];
    var cart = (_saleStore$keyToReadC = saleStore[keyToReadCartsObject]) === null || _saleStore$keyToReadC === void 0 ? void 0 : _saleStore$keyToReadC[0];
    if (!cart) {
      return breakdownItems;
    }
    var cartIdKey = keyToReadCarts === 'orders' ? 'orderNumber' : 'cartId';
    var cartType = keyToReadCarts === 'orders' ? saleStore[keyToReadCarts][0].orderType : saleStore[keyToReadCarts][0].type;
    breakdownItems.push({
      title: "Payment.Sale.PaymentDetails.PriceBreakdown",
      id: cart[cartIdKey]
    });
    pushProductLine({
      section: section,
      cart: cart,
      cartType: cartType
    });
    pushCouponLinePerCart({
      section: section,
      cart: cart
    });
    pushRulesLinePerCart({
      section: section,
      cart: cart
    });
    pushSubtotalLinePerCart({
      section: section,
      cart: cart
    });
    section.push({
      horizontalLine: true,
      label: "Payment.Sale.PaymentDetails.Total",
      price: currency + " " + formatPrice(saleStore.totalBreakDown.displayedTotal)
    });
    pushLoyaltyLine(section);
    pushTourismFeesLinePerCart({
      section: section,
      cart: cart,
      cartType: cartType
    });
    breakdownItems.push(section);
  } else {
    saleStore[keyToReadCarts].forEach(function (cartSimple) {
      var _cart$products6;
      var cartType = keyToReadCarts === 'orders' ? cartSimple.orderType : cartSimple.type;
      var cartIdKey = keyToReadCarts === 'orders' ? 'orderNumber' : 'cartId';
      var cart = saleStore[keyToReadCartsObject].find(function (cartObject) {
        return cartObject[cartIdKey] === cartSimple[cartIdKey];
      });
      var section = [];
      breakdownItems.push({
        title: getProductTitle({
          cartType: cartType,
          product: cart === null || cart === void 0 ? void 0 : (_cart$products6 = cart.products) === null || _cart$products6 === void 0 ? void 0 : _cart$products6.find(function (p) {
            return (p === null || p === void 0 ? void 0 : p.type) === cartType;
          })
        }),
        id: cart[cartIdKey]
      });
      pushProductLine({
        section: section,
        cart: cart,
        cartType: cartType
      });
      pushCouponLinePerCart({
        section: section,
        cart: cart
      });
      pushRulesLinePerCart({
        section: section,
        cart: cart
      });
      if (cart.displayItems.lineItems.length > 1) {
        pushSubtotalLinePerCart({
          section: section,
          cart: cart
        });
        section.push({
          horizontalLine: true,
          label: "Payment.Sale.PaymentDetails.Total",
          price: currency + " " + formatPrice(cart.displayItems.total.total)
        });
      }
      pushTourismFeesLinePerCart({
        section: section,
        cart: cart,
        cartType: cartType
      });
      breakdownItems.push(section);
    });
    var saleTotalSection = [];
    breakdownItems.push({
      title: "Payment.Sale.PaymentDetails.CartTotalsPayment"
    });
    saleStore[keyToReadCarts].forEach(function (cartSimple) {
      var cartType = keyToReadCarts === 'orders' ? cartSimple.orderType : cartSimple.type;
      var cartIdKey = keyToReadCarts === 'orders' ? 'orderNumber' : 'cartId';
      var cart = saleStore[keyToReadCartsObject].find(function (cartObject) {
        return cartObject[cartIdKey] === cartSimple[cartIdKey];
      });
      var price = cart.displayItems.total.total;
      saleTotalSection.push({
        label: getProductLabel({
          type: cartType,
          product: cart.products.find(function (p) {
            return p.type === cartType;
          })
        }),
        price: currency + " " + formatPrice(price)
      });
    });
    pushSubtotalLine(saleTotalSection);
    saleTotalSection.push({
      horizontalLine: true,
      label: "Payment.Sale.PaymentDetails.OverallTotal",
      price: currency + " " + formatPrice(saleStore.totalBreakDown.displayedTotal)
    });
    pushLoyaltyLine(saleTotalSection);
    breakdownItems.push(saleTotalSection);
  }
  return reorderPriceBreakDown({
    priceBreakDown: breakdownItems,
    saleStore: saleStore,
    hasMultiCart: saleStore.hasMultiCart
  });
};